import { render, staticRenderFns } from "./tablePreview.vue?vue&type=template&id=2cc460b5"
import script from "./tablePreview.vue?vue&type=script&lang=js"
export * from "./tablePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports